'use client'

import { ButtonV4 } from '@/components/v4/atoms/button/button'
import s from './enquiry-fixed-button.module.scss'
import { SendMsgIcon } from '@/components/svg/send-msg-icon/send-msg-icon'
import { useModal } from '@/hooks/use-modal'
import { useFooterVisible } from '@/hooks/use-footer-visible'

type Props = {
  formTitle?: string
  supplierId: number
  businessCategoryName?: string
  supplierSlug?: string
  supplierTitle?: string
}

export const EnquiryFixedButton = ({
  formTitle = 'Enquiry Now',
  supplierId,
  businessCategoryName,
  supplierSlug,
  supplierTitle,
}: Props) => {
  const modal = useModal()
  const isFooterVisible = useFooterVisible()

  const openEnquiryModal = () => {
    modal.open('supplier-enquiry-form', {
      modalProps: {
        enquiryForm: {
          title: formTitle,
          supplierId,
          businessCategoryName,
          supplierSlug,
          supplierTitle,
        },
      },
    })
  }

  if (isFooterVisible) {
    return null
  }

  return (
    <div className={s.enquiryBtnWrapper}>
      <ButtonV4
        variant="dark"
        className={s.enquiryBtn}
        onClick={openEnquiryModal}
      >
        {formTitle}
        <SendMsgIcon />
      </ButtonV4>
    </div>
  )
}
